import { render } from "./eyerweb-exam-show.vue?vue&type=template&id=6923837b&scoped=true"
import script from "./eyerweb-exam-show.vue?vue&type=script&lang=js"
export * from "./eyerweb-exam-show.vue?vue&type=script&lang=js"

import "./eyerweb-exam-show.vue?vue&type=style&index=0&id=6923837b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6923837b"]])

export default __exports__